import type { MODULATORS_CONSUMPTION_CHART_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/modulators-consumption-chart-card/modulators-consumption-chard-card.fr.ts";

export const MODULATORS_CONSUMPTION_CHART_CARD_ENGLISH_LOCALE = {
  title: "Modulator consumptions",
} satisfies typeof MODULATORS_CONSUMPTION_CHART_CARD_FRENCH_LOCALE;
